import { render } from "./AutomationTemplatesSellsy.vue?vue&type=template&id=113a5431&scoped=true"
import script from "./AutomationTemplatesSellsy.vue?vue&type=script&lang=js"
export * from "./AutomationTemplatesSellsy.vue?vue&type=script&lang=js"

import "./AutomationTemplatesSellsy.vue?vue&type=style&index=0&id=113a5431&lang=scss&scoped=true"
import "./AutomationTemplatesSellsy.vue?vue&type=style&index=1&id=113a5431&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-113a5431"]])

export default __exports__